import React from 'react';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const AdminPagination = ({ page, setPage, total, pageSize, testId }) => (
  <div className="flex items-center justify-between mt-4" data-testid={testId}>
    <p className="text-sm text-slate-400">
      {page * pageSize + 1}-{Math.min((page + 1) * pageSize, total)} / {total}
    </p>
    <div className="flex space-x-2">
      <Button variant="outline" size="sm" onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0} className="border-slate-700 h-8">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Button variant="outline" size="sm" onClick={() => setPage((p) => p + 1)} disabled={(page + 1) * pageSize >= total} className="border-slate-700 h-8">
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  </div>
);
